import { Query } from "@tanstack/vue-query";
import { matches } from "es-toolkit/compat";

// vue query key fragments can be of any type
export function hasAtLeastKeyPart(keyFragment: unknown) {
  return (q: Query): boolean => {
    return !!q.queryKey.find(matches(keyFragment));
  };
}
